"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = exports.MB = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var react_1 = require("react");
var theme_1 = require("../../theme");
var file_utils_1 = require("../../tools/file-utils");
var buttons_1 = require("../buttons");
var Icon_1 = require("../Icon");
var Typography_1 = require("../Typography");
var useDownloadFile_1 = require("./useDownloadFile");
var MB = function (megaByte) {
    // Base 2 calculation of bytes for 1 Megabyte
    return megaByte * 1024 * 1024 || 0;
};
exports.MB = MB;
var FileUpload = function (_a) {
    var _b;
    var onAddFiles = _a.onAddFiles, onRemoveFile = _a.onRemoveFile, onError = _a.onError, error = _a.error, _c = _a["data-testid"], testId = _c === void 0 ? 'fileUploadButton' : _c, _d = _a.title, title = _d === void 0 ? 'Upload a file or drag and drop' : _d, _e = _a.subTitle, subTitle = _e === void 0 ? 'Up to 10MB' : _e, _f = _a.icon, icon = _f === void 0 ? 'Upload01' : _f, _g = _a.removeText, removeText = _g === void 0 ? 'Remove' : _g, accept = _a.accept, className = _a.className, containerClassName = _a.containerClassName, fileListClassName = _a.fileListClassName, branding = _a.branding, _h = _a.files, previousFiles = _h === void 0 ? [] : _h, _j = _a.maxFileSize, maxFileSize = _j === void 0 ? (0, exports.MB)(24) : _j, _k = _a.maxFileCount, maxFileCount = _k === void 0 ? 10 : _k;
    var backgroundStateColors = (0, theme_1.useBackgroundStateActiveColors)(branding);
    var borderColors = (0, theme_1.useBorderColors)(branding);
    var inputRef = (0, react_1.useRef)(null);
    var _l = (0, react_1.useState)(false), shouldHighlight = _l[0], setShouldHighlight = _l[1];
    var _m = (0, react_1.useState)(previousFiles), files = _m[0], setFiles = _m[1];
    var downloadFile = (0, useDownloadFile_1.useDownloadFile)();
    var openFilePicker = (0, react_1.useCallback)(function () {
        var _a;
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }, []);
    var validateFile = (0, react_1.useCallback)(function (file) {
        if (files.length >= maxFileCount) {
            onError === null || onError === void 0 ? void 0 : onError('invalid.fileCount');
            return false;
        }
        if (!file) {
            onError === null || onError === void 0 ? void 0 : onError('invalid.file');
            return false;
        }
        if (!accept.includes(file.type)) {
            onError === null || onError === void 0 ? void 0 : onError('invalid.fileType');
            return false;
        }
        if (file.size > maxFileSize) {
            onError === null || onError === void 0 ? void 0 : onError('invalid.fileSize');
            return false;
        }
        return true;
    }, [onError, files]);
    var validateFileDrop = (0, react_1.useCallback)(function (dataTransferItems) {
        if (dataTransferItems.length + files.length > maxFileCount) {
            onError === null || onError === void 0 ? void 0 : onError('invalid.fileCount');
            return false;
        }
        return true;
    }, [onError, files]);
    var updateList = (0, react_1.useCallback)(function (newFiles) {
        setFiles((0, file_utils_1.sanitizeFiles)(__spreadArray(__spreadArray([], files, true), newFiles, true)));
        onAddFiles((0, file_utils_1.sanitizeFiles)(newFiles));
    }, [files, onAddFiles]);
    var handleDragOver = (0, react_1.useCallback)(function (e) {
        e.preventDefault();
        setShouldHighlight(true);
    }, []);
    var handleDragLeave = (0, react_1.useCallback)(function (e) {
        e.preventDefault();
        setShouldHighlight(false);
    }, []);
    var handleDrop = (0, react_1.useCallback)(function (event) {
        event.preventDefault();
        setShouldHighlight(false);
        var dropFiles;
        if (!validateFileDrop(event.dataTransfer.items))
            return;
        if (event.dataTransfer.items) {
            // Use DataTransferItemList interface to access the file(s)
            dropFiles = Array.from(event.dataTransfer.items).flatMap(function (item) {
                if (item.kind !== 'file') {
                    return [];
                }
                var file = item.getAsFile();
                return !validateFile(file) ? [] : [file];
            });
        }
        else {
            // Use DataTransfer interface to access the file(s)
            dropFiles = Array.from(event.dataTransfer.files);
        }
        if (dropFiles.length) {
            updateList(dropFiles);
        }
    }, [updateList, files]);
    var handleChange = (0, react_1.useCallback)(function (e) {
        var _a;
        var file = (_a = e.currentTarget.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file) {
            if (!validateFile(file)) {
                return;
            }
            updateList([file]);
        }
        e.target.value = null;
    }, [onAddFiles, files]);
    var handleRemove = (0, react_1.useCallback)(function (index) { return function () {
        if (files.length) {
            setFiles(files.filter(function (_, i) { return i !== index; }));
        }
        onRemoveFile === null || onRemoveFile === void 0 ? void 0 : onRemoveFile(index);
    }; }, [files, onRemoveFile]);
    var buttonTestId = "".concat(testId, "Button");
    return ((0, jsx_runtime_1.jsxs)("section", __assign({ "data-testid": testId, className: containerClassName }, { children: [(0, jsx_runtime_1.jsxs)("button", __assign({ "data-testid": buttonTestId, id: buttonTestId, type: "button", className: (0, classnames_1.default)("squid-flex \n          squid-flex-col \n          squid-border \n          squid-border-dashed\n          squid-rounded-lg \n          squid-items-center \n          squid-p-component-file-upload-padding \n          squid-space-x-component-file-space-base", borderColors.base, (_b = {},
                    _b[backgroundStateColors.base] = shouldHighlight,
                    _b[borderColors.hover] = shouldHighlight,
                    _b), className), onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop, onClick: openFilePicker, "aria-label": title }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: icon, highlight: "circle", fill: "base", size: "xl" }), (0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ strong: true, as: "h5", size: "base", color: "info", className: "squid-mt-2" }, { children: title })), (0, jsx_runtime_1.jsx)(Typography_1.Caption, __assign({ as: "h6", color: "weaker" }, { children: subTitle }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ "data-testid": "".concat(testId, "Files"), className: "squid-mb-4 squid-mt-4" }, { children: [error && ((0, jsx_runtime_1.jsx)(Typography_1.Caption, __assign({ as: "h6", "data-testid": "".concat(testId, "Error"), error: true }, { children: error }))), files.map(function (file, index) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ "data-testid": "".concat(testId).concat(file.name), className: (0, classnames_1.default)("\n              squid-flex \n              squid-flex-col \n              md:squid-flex-row \n              squid-items-start \n              squid-justify-between \n              squid-rounded-core-border-radius-md \n              squid-border \n              squid-px-4 \n              squid-py-4 \n              squid-mb-3\n            ", fileListClassName) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ role: "button", className: "squid-flex squid-flex-1 squid-items-center", "data-testid": "".concat(file.name, "DownloadButton"), onClick: function () { return downloadFile(file); }, "aria-label": "".concat(file.name, " Download Button"), tabIndex: 0 }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "squid-pr-2" }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { size: "xl", icon: "File05", highlight: "circle", fill: "base" }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "squid-flex squid-flex-col squid-gap-1" }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Body, __assign({ as: "h6", variant: "bold", size: "sm", color: "weaker" }, { children: file.name })), (0, jsx_runtime_1.jsx)(Typography_1.Caption, __assign({ "data-testid": "".concat(testId, "FileSize"), color: "weaker", size: "lg" }, { children: (0, file_utils_1.formatFileSize)(file.size) }))] }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "squid-flex squid-flex-col squid-gap-1" }, { children: (0, jsx_runtime_1.jsx)(buttons_1.Button, __assign({ "data-testid": "".concat(testId, "FileRemove"), variant: "text", onClick: handleRemove(index), tabIndex: 0, "aria-label": "".concat(testId, " Remove Button") }, { children: removeText })) }))] }), "".concat(file.name, "-").concat(index))); })] })), (0, jsx_runtime_1.jsx)("input", { "data-testid": "fileInput", id: "file", name: "file", hidden: true, type: "file", ref: inputRef, accept: accept.join(','), onChange: handleChange, "aria-labelledby": buttonTestId })] })));
};
exports.FileUpload = FileUpload;
